module.exports = __webpack_public_path__ + "img/prize-04.03c5bfca.png";